import CryptoJS from 'crypto-js';
import { keyCrypto } from './constants';

export const encryptEstandar = (plainText) => {
  const result = encryptAES(keyCrypto.Cryptography, plainText);
  return result;
}

export const decryptEstandar = (plainText) => {
  let result = plainText;
  try {
    result = decryptAES(keyCrypto.Cryptography, plainText);
  } catch (e) {
    // console.log('> error decrypt', plainText);
  }
  return result;
}

export const encryptAES = (password, plainText, config = { keySize: 256, iterations: 1 }) => {
  const { keySize } = config;
  const { iterations } = config;

  const salt = CryptoJS.lib.WordArray.random(128 / 8);

  const key = CryptoJS.PBKDF2(password, salt, {
    keySize: keySize / 32,
    hasher: CryptoJS.algo.SHA512,
    iterations: iterations,
  });

  const iv = CryptoJS.lib.WordArray.random(128 / 8);

  const encrypted = CryptoJS.AES.encrypt(plainText, key, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });

  const encryptedMessage = encrypted.toString() + iv.toString() + salt.toString();
  return encryptedMessage;
}

export const decryptAES = (password, encryptedMessage, config = { keySize: 256, iterations: 1 }) => {
  const { keySize } = config;
  const { iterations } = config;

  const salt = CryptoJS.enc.Hex.parse(encryptedMessage.substr(encryptedMessage.length - 32));
  const iv = CryptoJS.enc.Hex.parse(encryptedMessage.substr(encryptedMessage.length - 64, 32));
  const encrypted = encryptedMessage.substr(0, encryptedMessage.length - 64);

  const key = CryptoJS.PBKDF2(password, salt, {
    keySize: keySize / 32,
    hasher: CryptoJS.algo.SHA512,
    iterations: iterations,
  });

  const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });

  const decryptedMessage = decrypted.toString(CryptoJS.enc.Utf8);

  if (!decryptedMessage) {
    throw new Error('Decrypt Error');
  }

  return decryptedMessage;
}

export const hash224 = (message) => {
  const hash = CryptoJS.SHA224(message);
  return hash;
}

export const hash256 = (message) => {
  const hash = CryptoJS.SHA256(message);
  return hash;
}

export const hash384 = (message) => {
  const hash = CryptoJS.SHA384(message);
  return hash;
}

export const hash512 = (message) => {
  const hash = CryptoJS.SHA512(message);
  return hash;
}

export const hash3 = (message) => {
  const hash = CryptoJS.SHA3(message);
  return hash;
}
